import EmailConfirm from 'components/no-auth/email/EmailConfirm';
import Unsubscribe from 'components/no-auth/email/Unsubscribe';

import { AUTH_VIEW } from 'constants/ServerConstants';

import AntiFraudRecipientFlowPage from '../components/no-auth/antifraud/AntiFraudRecipientFlowPage';
import AntiFraudRecipientOnlyMotion from '../components/no-auth/antifraud/AntiFraudRecipientOnlyMotion';
import { PROMO } from '../constants/EntryPoint';

const noAuthWithJava = [
    {
        path: '/email/unsubscribe',
        component: Unsubscribe,
        view: AUTH_VIEW,
        isAuthZone: false,
        stateOptions: {
            entryPoint: PROMO,
        },
    },
    {
        path: '/email/confirm/:code',
        component: EmailConfirm,
        view: AUTH_VIEW,
        isAuthZone: false,
        isPathWithoutFooter: true,
        stateOptions: {
            entryPoint: PROMO,
        },
    },

    {
        path: '/web/af/:uuid/motion',
        component: AntiFraudRecipientOnlyMotion,
        view: AUTH_VIEW,
        isAuthZone: false,
        isPathWithoutFooter: true,
        stateOptions: {
            openChatInNoAuthZone: true,
        },
    },
    {
        path: '/web/af/:uuid',
        component: AntiFraudRecipientFlowPage,
        view: AUTH_VIEW,
        isAuthZone: false,
        isPathWithoutFooter: true,
        stateOptions: {
            openChatInNoAuthZone: true,
        },
    },
];

export default noAuthWithJava;
